import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private readonly title: Title,
    private readonly translate: TranslateService
  ) {}

  public setPageTitle(
    title: string,
    data?: { [key: string]: string | number }
  ): void {
    this.title.setTitle(
      title
        ? this.translate.instant('app.title', {
            title: this.translate.instant(title, data),
          })
        : ''
    );
  }
}
